import React, { useContext, useEffect, useState } from "react";
import { SearchIcon } from "../../Assets/Icons";
import { SearchContext } from "../../store/context/searchContext";

const SearchBox = () => {
  const { search, setSearch } = useContext(SearchContext);
  const [inputValue, setInputValue] = useState(search);

  useEffect(() => {
    const handler = setTimeout(() => {
      setSearch(inputValue);
    }, 250);

    return () => {
      clearTimeout(handler);
    };
  }, [inputValue]);

  return (
    <>
      <div className="main-search">
        <span className="search-icon">
          <SearchIcon />
        </span>
        <input
          type="text"
          className="form-control"
          placeholder="Search 3D Models"
          autoComplete="off"
          value={inputValue}
          onChange={(e) => setInputValue(e.target.value)}
        />
      </div>
    </>
  );
};

export default SearchBox;
